export default function getCoverPhotoUrl(coverPhoto, options = { thumb: false }) {
  if (
    !coverPhoto ||
    typeof coverPhoto !== "string" ||
    coverPhoto.endsWith(".png") ||
    coverPhoto.endsWith(".jpeg")
  ) {
    // Do nothing and return the value if it's an image string or a null value
    return coverPhoto;
  }

  const imageType = options.thumb ? "thumb" : "main";
  return `${coverPhoto}/${imageType}.png`;
}
